'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataModel = require('./backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

var _dataCollection = require('./backbone/dataCollection');

var _dataCollection2 = _interopRequireDefault(_dataCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class() {
        var queriesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, _class);

        if (!(queriesData instanceof Array)) {
            queriesData = [queriesData];
        }

        this.queriesData = queriesData;
        return this;
    }

    _createClass(_class, [{
        key: 'query',
        value: function query() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.queriesData) {
                return Promise.reject();
            }

            if (typeof options.beforeSend === 'function') {
                options.beforeSend();
            }

            var _error = void 0;

            return Promise.all(this.queriesData.map(function (item) {
                // make Promise from every query
                return new Promise(function (resolve, reject) {
                    var method = item.method,
                        storage = item.storage;

                    // no storage/method for query
                    if (!method || !storage || !storage[method]) {
                        reject();
                    }

                    storage[method].call(storage, Object.assign({}, item.options || {}, {
                        success: function success(data) {
                            if (!(storage instanceof _dataModel2.default || storage instanceof _dataCollection2.default) && typeof storage.success === 'function') {
                                storage.success(data);
                            }

                            resolve(data);
                        },
                        error: function error(e) {
                            _error = e;
                            resolve(e);
                        }
                    }));
                });
            })).then(
            // Разруливаем error, success тут
            // для того что бы пул запросов был неблокирующий
            function (data) {
                if (_error) {
                    if (typeof options.error === 'function') {
                        options.error(_error);
                    }
                } else {
                    if (typeof options.success === 'function') {
                        options.success.apply(options, _toConsumableArray(data));
                    }
                }

                if (typeof options.complete === 'function') {
                    options.complete();
                }

                if (_error) {
                    return Promise.reject(_error);
                } else {
                    return Promise.resolve.apply(Promise, _toConsumableArray(data));
                }
            });
        }
    }]);

    return _class;
}();

exports.default = _class;